import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { TERMS_SECTIONS } from "./content";
import "../../CSS/TermsConditions/modern.css";

const TermsConditions = () => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 120;
      let current = "";
      TERMS_SECTIONS.forEach((section) => {
        const el = document.getElementById(section.id);
        if (el && el.offsetTop <= scrollPos) {
          current = section.id;
        }
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <AdminLayout>
      <div className="terms-page">
        <section className="terms-hero">
          <div className="terms-hero__inner">
            <span className="terms-hero__badge">
              <GavelOutlinedIcon sx={{ fontSize: 18 }} />
              Legal
            </span>
            <h1 className="terms-hero__title">{t("page_title_terms_conditions")}</h1>
            <p className="terms-hero__meta">Last updated: May 2026</p>
          </div>
        </section>

        <section className="terms-body">
          <div className="terms-body__inner">
            <nav className="terms-toc" aria-label="Table of contents">
              <p className="terms-toc__title">On this page</p>
              <ul className="terms-toc__list">
                {TERMS_SECTIONS.map((section) => (
                  <li key={section.id}>
                    <a
                      href={`#${section.id}`}
                      className={`terms-toc__link${
                        activeSection === section.id ? " terms-toc__link--active" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection(section.id);
                      }}
                    >
                      {t(section.titleKey)}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="terms-content">
              {TERMS_SECTIONS.map((section) => (
                <article key={section.id} id={section.id} className="terms-section">
                  <h2 className="terms-section__title">{t(section.titleKey)}</h2>
                  {section.paragraphKeys.map((key) => (
                    <p key={key}>{t(key)}</p>
                  ))}
                  {section.id === "privacy" && (
                    <p>
                      <Link to="/privacypolicy" className="terms-section__inline-link">
                        Read our Privacy Policy
                      </Link>
                    </p>
                  )}
                </article>
              ))}

              <div className="terms-cta">
                <h3 className="terms-cta__title">Related policies</h3>
                <p className="terms-cta__text">
                  Review our other legal documents for complete information.
                </p>
                <div className="terms-cta__links">
                  <Link to="/privacypolicy" className="terms-cta__link">
                    Privacy Policy
                    <ArrowForwardIcon fontSize="small" />
                  </Link>
                  <Link to="/cookies-policy" className="terms-cta__link">
                    Cookies Policy
                    <ArrowForwardIcon fontSize="small" />
                  </Link>
                  <Link to="/contact" className="terms-cta__link terms-cta__link--outline">
                    Contact us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        </div>
    </AdminLayout>
  );
};

export default TermsConditions;
